"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { WAVE_DEFAULT_SUBSCRIPTION_ACTIONS } from "@/components/react-query-wrapper/utils/query-utils";
import { FOLLOW_BTN_BUTTON_CLASSES, FOLLOW_BTN_LOADER_SIZES, UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import type { ApiWaveSubscriptionActions } from "@/generated/models/ApiWaveSubscriptionActions";
import type { ApiWaveOverview } from "@/generated/models/ApiWaveOverview";
import { commonApiDeleteWithBody, commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { useContext, useState } from "react";
import { FollowBtnCheckIcon, FollowBtnPlusIcon } from "../notificationsFollowShared";
export default function NotificationWaveFollowBtn(t0) {
  const $ = _c(42);
  const {
    wave,
    size: t1
  } = t0;
  const size = t1 === undefined ? UserFollowBtnSize.SMALL : t1;
  const {
    setToast,
    requestAuth
  } = useAuth();
  const {
    onWaveFollowChange
  } = useContext(ReactQueryWrapperContext);
  const [followingOverride, setFollowingOverride] = useState(null);
  const [mutating, setMutating] = useState(false);
  const following = followingOverride ?? wave.context_profile_context?.subscribed ?? false;
  let t2;
  if ($[0] !== wave) {
    t2 = async () => {
      await commonApiPost({
        endpoint: `waves/${wave.id}/subscriptions`,
        body: {
          actions: WAVE_DEFAULT_SUBSCRIPTION_ACTIONS
        }
      });
      await commonApiPost({
        endpoint: `notifications/wave-subscription/${wave.id}`,
        body: {}
      });
    };
    $[0] = wave;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onWaveFollowChange || $[3] !== wave) {
    t3 = () => {
      setFollowingOverride(true);
      onWaveFollowChange({
        waveId: wave.id,
        following: true
      });
    };
    $[2] = onWaveFollowChange;
    $[3] = wave;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== setToast) {
    t4 = error => {
      setToast({
        message: error instanceof Error ? error.message : String(error),
        type: "error"
      });
    };
    $[5] = setToast;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setMutating(false);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t6 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: t4,
      onSettled: t5
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const followMutation = useMutation(t6);
  let t7;
  if ($[12] !== wave) {
    t7 = async () => {
      await commonApiDeleteWithBody({
        endpoint: `waves/${wave.id}/subscriptions`,
        body: {
          actions: WAVE_DEFAULT_SUBSCRIPTION_ACTIONS
        }
      });
    };
    $[12] = wave;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onWaveFollowChange || $[15] !== wave) {
    t8 = () => {
      setFollowingOverride(false);
      onWaveFollowChange({
        waveId: wave.id,
        following: false
      });
    };
    $[14] = onWaveFollowChange;
    $[15] = wave;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== setToast) {
    t9 = error_0 => {
      setToast({
        message: error_0 instanceof Error ? error_0.message : String(error_0),
        type: "error"
      });
    };
    $[17] = setToast;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setMutating(false);
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t11 = {
      mutationFn: t7,
      onSuccess: t8,
      onError: t9,
      onSettled: t10
    };
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const unFollowMutation = useMutation(t11);
  let t12;
  if ($[24] !== followMutation || $[25] !== following || $[26] !== requestAuth || $[27] !== unFollowMutation) {
    t12 = async () => {
      setMutating(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setMutating(false);
        return;
      }
      if (following) {
        await unFollowMutation.mutateAsync();
        return;
      }
      await followMutation.mutateAsync();
    };
    $[24] = followMutation;
    $[25] = following;
    $[26] = requestAuth;
    $[27] = unFollowMutation;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const onFollow = t12;
  const label = following ? "Joined" : "Join";
  let t13;
  bb0: {
    if (mutating) {
      const t14 = FOLLOW_BTN_LOADER_SIZES[size];
      let t15;
      if ($[29] !== t14) {
        t15 = <CircleLoader size={t14} />;
        $[29] = t14;
        $[30] = t15;
      } else {
        t15 = $[30];
      }
      t13 = t15;
      break bb0;
    }
    if (following) {
      let t14;
      if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = <FollowBtnCheckIcon />;
        $[31] = t14;
      } else {
        t14 = $[31];
      }
      t13 = t14;
      break bb0;
    }
    let t14;
    if ($[32] !== size) {
      t14 = <FollowBtnPlusIcon size={size} />;
      $[32] = size;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    t13 = t14;
  }
  const icon = t13;
  const t14 = `${FOLLOW_BTN_BUTTON_CLASSES[size]} ${following ? "tw-bg-iron-800 tw-text-iron-300 tw-ring-iron-800 hover:tw-bg-iron-700 hover:tw-ring-iron-700" : "tw-bg-primary-500 tw-text-white tw-ring-primary-500 hover:tw-bg-primary-600 hover:tw-ring-primary-600"} tw-flex tw-cursor-pointer tw-items-center tw-rounded-lg tw-border-0 tw-font-semibold tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t15;
  if ($[34] !== label) {
    t15 = <span>{label}</span>;
    $[34] = label;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== icon || $[37] !== mutating || $[38] !== onFollow || $[39] !== t14 || $[40] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-2"><button onClick={onFollow} disabled={mutating} type="button" className={t14}>{icon}{t15}</button></div>;
    $[36] = icon;
    $[37] = mutating;
    $[38] = onFollow;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  return t16;
}